import { DEFAULT_STATE_FETCH_PERIODS } from '../../../common/constants/filterPeriods';
import { TReduxActions } from '../../../common/types/redux';
import { EPeriodsActionTypes } from '../../actions/options/types';

import { EPeriodsStatus, IOptionsState } from '../../types/options';

export const defaultState: IOptionsState = {
  options: DEFAULT_STATE_FETCH_PERIODS,
  status: EPeriodsStatus.Initial,
};

export const optionsReducer = (state: IOptionsState = defaultState, action: TReduxActions) => {
  switch (action.type) {
    case EPeriodsActionTypes.Succeed:
      return { ...state, options: action.payload, status: EPeriodsStatus.Succeed };
    case EPeriodsActionTypes.Loading:
      return { ...state, status: EPeriodsStatus.Loading };
    case EPeriodsActionTypes.Failed:
      return { ...state, options: DEFAULT_STATE_FETCH_PERIODS, status: EPeriodsStatus.Failed };
    default:
      return state;
  }
};
